
interface PaymentSummaryProps {
  strategy?: {
    name?: string;
  };
  isYearly?: boolean;
  amount: string;
  discountedAmount?: string;
}

const PaymentSummary = ({ strategy, isYearly, amount, discountedAmount }: PaymentSummaryProps) => {
  return (
    <div className="flex justify-between items-start mb-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-800">
          {strategy?.name || "Premium"} Subscription
        </h2>
        <p className="text-gray-500">
          {isYearly ? "Annual" : "Monthly"} Plan
        </p>
      </div>
      <div className="text-right">
        {discountedAmount ? (
          <div>
            <p className="text-gray-500 line-through">
              ${amount}
              <span className="text-sm">
                /{isYearly ? "year" : "month"}
              </span>
            </p>
            <p className="text-2xl font-bold text-[#007BFF]">
              ${discountedAmount}
              <span className="text-sm text-gray-500">
                /{isYearly ? "year" : "month"}
              </span>
            </p>
          </div>
        ) : (
          <p className="text-2xl font-bold text-[#007BFF]">
            ${amount}
            <span className="text-sm text-gray-500">
              /{isYearly ? "year" : "month"}
            </span>
          </p>
        )}
        {isYearly && !discountedAmount && (
          <span className="text-green-600 text-sm bg-green-50 px-2 py-1 rounded-full">
            Save 2 months! 🎉
          </span>
        )}
      </div>
    </div>
  );
};

export default PaymentSummary;
